import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Country } from 'app/masters/models/branch-master.model';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { LocationService } from '../location.service';
import { SearchStateMasterComponent } from './search-state-master/search-state-master.component';

@Component({
  selector: 'app-state-master',
  templateUrl: './state-master.component.html',
  styleUrls: ['./state-master.component.scss']
})
export class StateMasterComponent implements OnInit {
  countryIndex = [];
  activeCountry: Country[] = [];
  filteredCountryArray: Observable<any[]>;
  fkCountryId: FormControl;
  stateForm: FormGroup;
  public selectStateObj: any = {};
  selectedStateId: any;
  countryname: any;
  SavingPayLoad: any;
  popbutton:any;
  enabledisablebtn:boolean =false;
  statelistdata: any;
  constructor(public dialog: MatDialog, public locationService: LocationService, private _fb: FormBuilder,public dialogRef: MatDialogRef<StateMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.getCountryList();
    dialogRef.disableClose = true;
  }

  ngOnInit(): void {
    this.enabledisablebtn=true;
    this.referedbyControll();
    this.loadCountryForm();
    this.getStateList();
    this.popbutton =0;
    if(this.data.id !=null && this.data.id !=undefined){
      this.popbutton =this.data.id;
    }
  }
  enableButton($event){ 
       
    const form = this.stateForm.controls;
    if(form.fkCountryId.value == '' || form.stateName.value == ''){
      this.enabledisablebtn= true;
    }else{
      this.enabledisablebtn=false;
    }
  }
  closedailog(){
    this.dialogRef.close();
  }
  loadCountryForm() {
    this.enabledisablebtn= true;
    this.countryname = ''
    this.stateForm = this._fb.group({
      pkStateId: ' ',
      fkCountryId: ['', [Validators.required]],
      stateName: ['', [Validators.required]],
      sateCode: ['', [Validators.required]],
      isActive: false
    });
  }
  onchnagecountryName(e:any){
    
    this.enableButton(e.option.id);
      }

  /* Get Country APi */
  getCountryList() {
    this.locationService.getCountry().subscribe(data => {
      // let countryListActive = data;
      // this.activeCountry = data;
       this.activeCountry = data.filter((country: any) => country.isActive === true);
      // for (var _i = 0; _i < countryListActive.length; _i++) {
      //   if (countryListActive[_i].isActive == true) {
      //     this.countryIndex.push(countryListActive[_i]);
      //     this.activeCountry = this.countryIndex;
      //     console.log( this.activeCountry);
      //   }
      // }
      this.referedbyControll();
    });
  }

  referedbyControll() {
    this.fkCountryId = new FormControl();
    this.filteredCountryArray = this.fkCountryId.valueChanges
      .pipe(
        startWith(''),
        map(country => country ? this.filterCountryfunction(country) : this.activeCountry.slice())
      );
  }

  filterCountryfunction(name: string) {
    return this.activeCountry.filter(country =>
      country.countryName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }


  /** Seach Branch Master */
  searchSateMaster() {
    const dialogRef1 = this.dialog.open(SearchStateMasterComponent, {
      panelClass: "full-width-dialog",
      maxWidth: "100vw !important",
      height: "450px",
      width: "60%",
    });

    dialogRef1.afterClosed().subscribe(result => {
      this.selectStateObj = this.locationService.selecteStateData
      if (this.selectStateObj != null) {
        this.enabledisablebtn=false;
        this.selectedStateId = this.selectStateObj.pkStateId;
        this.setupdateStateForm(this.selectedStateId);
      }
    });
  }

  setupdateStateForm(stateId) {
    this.locationService.getStateItem(stateId).subscribe(data => {
      let selectedStatedata = data[0];
      let countryName = this.activeCountry.filter(item => item.pkCountryId == selectedStatedata.fkCountryId);
      this.countryname = countryName[0].countryName;
      this.stateForm.patchValue(
        {
          pkStateId: selectedStatedata.pkStateId,
          fkCountryId: this.countryname,
          stateName: selectedStatedata.stateName,
          sateCode: selectedStatedata.sateCode,
          isActive: selectedStatedata.isActive,
          pK_SynchId: selectedStatedata.pK_SynchId,
        });
    });

  }
  getStateList() {
    this.locationService.getState().subscribe(data => {
      this.statelistdata = data
    });
  }
  saveStateForm(event) {
     const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);
    
    let countryId 
    const form = this.stateForm.controls;
    let countryName = this.activeCountry.filter(item => item.countryName.toLowerCase() == form.fkCountryId.value.toLowerCase());
    if (countryName.length == 0) {
      this.locationService.openSnackBar("Please select a valid country", "OK");
      return;
    }
    countryId = countryName[0].pkCountryId;

 
    // const stateNameData = this.statelistdata.filter(item => 
    //   item.stateName.toLowerCase() === form.stateName.value.toLowerCase() &&
    //   item.fkCountryId === countryId);   
    //  if(stateNameData.length >0){      
    //     this.locationService.openSnackBar("Already Exists in  list" , "OK");
    //     this.loadCountryForm();
    //     return
    // }
    if (form.pkStateId.value === ' ') {  
    this.SavingPayLoad = {
      fkCountryId: countryId,
      stateName: form.stateName.value,
      sateCode: form.sateCode.value,
      isActive: form.isActive.value,
      pkStateId: form.pkStateId.value
    }

      delete this.SavingPayLoad.pkStateId;
      this.locationService.addStateMaster(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {        
          this.locationService.openSnackBar("Record Saved Successfully ", "OK");
          this.loadCountryForm();
          this.getStateList();
        }
      },
      err => {
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
      }
    );
    } else {
      this.SavingPayLoad = {
        fkCountryId: countryId,
        stateName: form.stateName.value,
        sateCode: form.sateCode.value,
        isActive: form.isActive.value,
        pkStateId: form.pkStateId.value
      }
      this.locationService.addStateMaster(this.SavingPayLoad).subscribe(data => {
        if (data.statusCode == 1) {
          this.locationService.openSnackBar("Record Updated Successfully " , "OK");
          this.loadCountryForm();
          this.getStateList();
        }
      },
      err => {
        if (err.status == 403) {
          this.locationService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.locationService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.locationService.openSnackBar("API Failed", "OK");
        }
      }


    );
    }
  }

}
